import {createDocumentResource, createQueryResource, list} from "retil";
import axios from 'axios';
import {LiveSchedule} from "@2021-contest-web/components/src/types";
import {isMock} from "./config";

export const liveSchedule = createDocumentResource<LiveSchedule>('liveSchedule');
export const liveScheduleList = createQueryResource('liveScheduleList', {
  for: list(liveSchedule),
  load: async (room_id: number|string) => {
    if (isMock()) {
      return [];
    }
    try {
      const res = await axios.get(`https://marquez.age.co.jp/schedule/${room_id}.json`)
      return res.data;
    } catch {
      return [];
    }
  }
});
